import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoggingService } from '@core/services/logging.service';

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const loggingService = inject(LoggingService);
  
  return next(req).pipe(
    tap(event => {
      if (event.type === HttpEventType.Response) {
        // Only log in non-production environments to avoid performance overhead
        loggingService.debug(req.url, 'returned a response with status', event.status);
      }
    })
  );
}